unit UHelperServer;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Controls, WEBLib.Grids,
  WEBLib.ExtCtrls, WEBLib.WebCtrls, Web, JS, DateUtils, XData.Web.Dataset,
  System.StrUtils, Data.DB, XData.Web.Request, WEBLib.DBCtrls, UUtils,
  UWeb.Enum,
  UPersonalizacao_Tabela.Interfaces;


type
  TTipoPagina = (LISTAGEM, EDICAO, CADASTRO);

  THelperServer = class
    class var FQuery : string;
    class var FQueryProdutos : string;
    class var FFilterParametro : string;

    [async]
    class procedure RemoverElementoPorId(pId : string); async;
    class procedure AtualizarTituloPagina(pTipoPagina : TTipoPagina; pTexto : string);
    class procedure RemoverDiv(pElementoDivId : string);
    class function GetTempoSincronizacao(pInicio, pFim : string) : string;
    [async]
    class procedure ChamarConsulta(pTitulo, pTabela : string; pEdit : TEdit;
      pIgnorarVazio : Boolean = False); async;
    class function GetMensagemBotaoSalvar(pInsert : Boolean; pTela : string) : string;
    class procedure ConverterCdsEmCombo(pCds: TXDataWebDataSet; var pCombo: TComboBox);
    class function GetIdCombo(pCds: TXDataWebDataSet; pIndex : Integer): Integer;
    class procedure SetIndexCombo(pCds: TXDataWebDataSet; pValor : Integer; var pCombo: TComboBox);
    class procedure ElementoHide(pElementoId : string);
    class procedure ElementoShow(pElementoId : string);
    class function GetBooleanValor(pValor: string) : Boolean;
    class function GetValueOrNull(pValor : string): JSValue;
    class function GetDataExcel(pData : string) : string;
    class function ValidarExtensaoImagemProduto(pNomeArquivo : string) : Boolean;
    class function ValidarTamanhoImagemProduto(pSize : Integer) : Boolean;
    class function GetValueOrEmpty(pValor : string) : string;
    class function GetStatusAssociacaoProdutoRounded(pStatus : string): string;
    class function ConverterData(pData : string) : string;
    class function VerificarCampoVazio(pEdit : TDBEdit) : Boolean;
    class function GetMensagemPadraoSalvar(pInserting : Boolean) : string;
    class function GetMensagemPadraoSalvarSucesso(pInserting : Boolean) : string;
    class function GerarDataExcel(pValor : string) : string;
    class function GetTextoMax100Caracteres(pTexto : string): string;
    class function FormatarEndereco(pEndereco, pNumero, pBairro, pComplemento : string;
      pTabela: Boolean = True) : string;
    class function GetTelefoneUnicoJson(pJson : string) : string;
    class function GetTodosTelefonesJson(pJson : string) : string;
    class function FormatarDocumento(pDocumento : string; pParcela : Integer) : string;
    class procedure BaixarAnexo(pBase64, pArquivoNome: string);
    class procedure CopiarTextoNotificacao(pMensagem, pTitulo, pTexto : string);
    class function GetValorOrEmpty(pValor : string) : string;
    class function PossuiImagem(pValor : string) : Boolean;
    class function GetStatusAssociacao(pStatus : string) : string;
    class function GetCodigoBarrasGeradoPeloSistema(pCodigoInterno : string) : string;
    class function GetNumber(pAText: string; pAFromText: string = ','; AToText: string = '.'): string;
    class function str_zero_dir(pStr: string; pTamanho: Integer = 0; pCaracter: Char = '0'): string;
    class function Par(pCod: Integer): Boolean;
    class function CodigoBarrasGeradoPeloSistema(pCodigoBarras, pCodigoInterno : string): Boolean;
    class function FormatarNumeroBigInt(pValor : Int64) : string;
    class function ValidarDatasMovimentos(pDataInicial,pDataFinal : string) : string;
    class function FormatarDataPTBR(pData : string) : string;
    class function FormatarJSON(const pJson: string; pIdentar: Boolean): string;
    class function VerificarJsonValido(pJson : string) : Boolean;
    class function IsSelectSomente(const ASQL: string): Boolean;
    class function VerificarJsonArrayValido(const pJson: string): Boolean;
  end;

implementation

uses
  View.Dialog,
  View.Consulta_Sistema;

{ THelperMensagem }


class procedure THelperServer.AtualizarTituloPagina(pTipoPagina: TTipoPagina;
  pTexto: string);
var
  lTitulo : string;
  lBreadcrumbTitulo: string;
  lElement: TJSHTMLElement;
  lPaginaListagem: Boolean;
begin
  lPaginaListagem := pTipoPagina = TTipoPagina.LISTAGEM;

  case pTipoPagina of
    TTipoPagina.LISTAGEM :
    begin
      lTitulo := 'Listagem de ' + pTexto;
      lBreadcrumbTitulo := pTexto;
    end;
    TTipoPagina.EDICAO :
    begin
      lTitulo := 'Edição de ' + pTexto;
      lBreadcrumbTitulo := 'Edição';
    end;
    TTipoPagina.CADASTRO :
    begin
      lTitulo := 'Cadastro de ' + pTexto;
      lBreadcrumbTitulo := 'Cadastro';
    end;
  end;

  lElement := TJSHTMLElement(document.getElementById('view.crudcontainer.title'));

  if Assigned(lElement) then
  begin
    // Breadcrumb centralizado para todas as telas CRUD. Os grupos do menu apenas
    // expandem o menu lateral; as paginas reais continuam navegando por hash.
    asm
      var titleEl = lElement;
      var pageTitle = String(lBreadcrumbTitulo || '').replace(/_/g, ' ');
      var hash = String(window.location.hash || '');
      var route = hash.replace(/^#\/?/, '').split('?')[0].split('/')[0].replace(/-/g, '_');
      var menuItem = route ? document.getElementById(route) : null;

      function textOf(el) {
        if (!el) return '';
        var label = el.querySelector('a > p, a > span');
        return String((label ? label.textContent : el.textContent) || '').trim();
      }

      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(new RegExp(String.fromCharCode(34), 'g'), '&quot;')
          .replace(new RegExp(String.fromCharCode(39), 'g'), '&#39;');
      }

      function routeHash(value) {
        return '#/' + encodeURIComponent(String(value || '').replace(/_/g, '-'));
      }

      var crumbs = [
        { text: 'Início', href: '#/home' }
      ];

      if (menuItem) {
        var parents = [];
        var node = menuItem.parentElement;
        while (node) {
          if (node.classList && node.classList.contains('menu_principal')) {
            parents.unshift(node);
          }
          node = node.parentElement;
        }

        parents.forEach(function (parent) {
          var label = textOf(parent);
          if (label) {
            crumbs.push({ text: label, menuId: parent.id });
          }
        });

        var menuText = textOf(menuItem);
        if (menuText) {
          pageTitle = menuText;
        }
      }

      if (lPaginaListagem) {
        crumbs.push({ text: pageTitle, active: true });
      } else {
        if (route) {
          crumbs.push({ text: pageTitle, href: routeHash(route) });
        } else {
          crumbs.push({ text: pageTitle });
        }
        crumbs.push({ text: String(lBreadcrumbTitulo || ''), active: true });
      }

      titleEl.innerHTML = '<div class="facil-page-title">' + escapeHtml(lTitulo) + '</div>' +
        '<nav class="facil-breadcrumb" aria-label="breadcrumb"><ol>' +
        crumbs.map(function (crumb) {
          var text = escapeHtml(crumb.text);
          if (crumb.active) {
            return '<li class="active text-primary" aria-current="page">' + text + '</li>';
          }
          if (crumb.href) {
            return '<li><a href="' + escapeHtml(crumb.href) + '">' + text + '</a></li>';
          }
          if (crumb.menuId) {
            return '<li><a href="#" data-breadcrumb-menu="' + escapeHtml(crumb.menuId) + '">' + text + '</a></li>';
          }
          return '<li>' + text + '</li>';
        }).join('') + '</ol></nav>';

      titleEl.querySelectorAll('[data-breadcrumb-menu]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          var menu = document.getElementById(link.getAttribute('data-breadcrumb-menu'));
          var toggle = menu && menu.querySelector(':scope > a[data-bs-toggle="collapse"]');
          if (toggle) toggle.click();
        });
      });
    end;
  end;
end;

class procedure THelperServer.BaixarAnexo(pBase64, pArquivoNome: string);
var
  lFileData: WideString;
  lTamanhoArquivo,
  lIndice : Integer;
  AB: TJSArrayBuffer;
  AV: TJSUInt8Array;
begin
  lFileData := window.atob(pBase64);
  lTamanhoArquivo := Length(lFileData);

  if (lTamanhoArquivo <> -1) then
  begin
    AB := TJSArrayBuffer.new(lTamanhoArquivo);
    AV := TJSUInt8Array.new(AB);
    for lIndice := 0 to lTamanhoArquivo - 1 do
      AV[lIndice] := TJSString(lFileData).charCodeAt(lIndice);
    Application.DownloadBinaryFile(AV, pArquivoNome);

    TUtils.OcultarDivLoading;
  end
end;

class procedure THelperServer.ChamarConsulta(pTitulo, pTabela : string; pEdit : TEdit;
  pIgnorarVazio : Boolean);
var
  Consulta: TConsulta_Sistema;
begin
  if not TUtils.PossuiPermissao(pTabela.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Usuário sem permissão para visualizar' +
      ' dados de ' + pTitulo + '!');

    Exit;
  end;

  Consulta := TConsulta_Sistema.Create(nil);
  try
    Consulta.Caption := 'Child form';
    Consulta.Popup := True;
    Consulta.PopupOpacity := 0.2;
    Consulta.FTituloConsulta := pTitulo;
    Consulta.FConsultaTabela := pTabela;
    Consulta.FIgnorarVazio := pIgnorarVazio;
    Consulta.FEdit := pEdit;
    Consulta.Width := 400;
    Consulta.Height := 300;
    //window.location.hash := 'subform';

    Await(TDialog, Consulta.Load());
    Await(TModalResult, Consulta.Execute);
  finally
    //Result := Dialog.FResult;
    Consulta.Free;
  end;
end;

class function THelperServer.CodigoBarrasGeradoPeloSistema(pCodigoBarras,
  pCodigoInterno: string): Boolean;
var
  lCodigoSistema : string;
begin
  Result := False;

  lCodigoSistema := GetCodigoBarrasGeradoPeloSistema(pCodigoInterno);

  Result := lCodigoSistema = pCodigoBarras;
end;

class procedure THelperServer.ConverterCdsEmCombo(pCds: TXDataWebDataSet;
  var pCombo: TComboBox);
var
  pCampoDescricao : string;
begin
  pCombo.Items.Clear;
  pCds.DisableControls;

  try
    pCds.First;
    pCombo.Items.Add(' ');
    while not pCds.Eof do
    begin
      case IndexStr(UpperCase(pCds.EntitySetName), ['RT_IBS_CBS_CST', 'RT_IS_CST']) of
        0, 1 :
        begin
          pCombo.Items.Add(pCds.FieldByName('cst').AsString + ' - ' +
            pCds.FieldByName('descricao').AsString);
        end
        else pCombo.Items.Add(pCds.FieldByName('nome').AsString);
      end;

      pCds.Next;
    end;
  finally
    pCds.EnableControls;
  end;
end;

class function THelperServer.ConverterData(pData: string): string;
var
  lJSDate: TJSDate;
  lData : TDateTime;
  lErro : string;
begin
  try
    if Trim(pData).IsEmpty then
    begin
      Result := EmptyStr;
      Exit;
    end;

    if TryStrToDate(pData, lData) then
    begin
      Result := DateToStr(lData);
      Exit;
    end;

    lJSDate := TJSDate.New(pData);
    Result := FormatDateTime('dd/mm/yyyy', EncodeDate(lJSDate.UTCFullYear, lJSDate.UTCMonth + 1, lJSDate.UTCDate));
  except
    Result := GerarDataExcel(pData);
  end;
end;

class procedure THelperServer.CopiarTextoNotificacao(pMensagem, pTitulo, pTexto: string);
begin
  asm
    navigator.clipboard.writeText(pTexto);
    dispararNotificacao(pTitulo, pMensagem);
  end;
end;

class procedure THelperServer.ElementoHide(pElementoId: string);
begin
  asm
    $('#' + pElementoId).hide();
  end;
end;

class procedure THelperServer.ElementoShow(pElementoId: string);
begin
  asm
    $('#' + pElementoId).show();
  end;
end;

class function THelperServer.FormatarDataPTBR(pData: string): string;
begin
  Result := Copy(pData, 9, 2) + '/' + Copy(pData, 6, 2) + '/' + Copy(pData, 1, 4) +
    ' ' + Copy(pData, 12, 8);
end;

class function THelperServer.FormatarDocumento(pDocumento : string; pParcela : Integer): string;
var
  lParcela : string;
begin
  lParcela := Format('%.3d', [pParcela]);

  Result := pDocumento + '/' + lParcela;
end;

class function THelperServer.FormatarEndereco(pEndereco, pNumero, pBairro,
  pComplemento: string; pTabela: Boolean): string;
begin
  Result := EmptyStr;

  if pEndereco.IsEmpty then
    Exit;

  if pTabela then
  begin
    Result := pEndereco + ', N° ' + pNumero + ', ' + pBairro;

    Result := GetTextoMax100Caracteres(Result);
  end
  else
  begin
    Result := 'Rua: ' + pEndereco + ', ' + 'Nº: ' + pNumero + sLineBreak + 'Bairro: ' +
      pBairro + sLineBreak + 'Complemento: ' + pComplemento;
  end;

  Result := Result.ToUpper;
end;

class function THelperServer.FormatarJSON(const pJson: string;
  pIdentar: Boolean): string;
var
  lJSONObj: JSValue;
begin
  lJSONObj := TJSJSON.parse(pJson);
  if pIdentar then
    Result := TJSJSON.stringify(lJSONObj, nil, 2)
  else
    Result := TJSJSON.stringify(lJSONObj);
end;

class function THelperServer.FormatarNumeroBigInt(pValor: Int64): string;
var
  lMyFormatSettings: TFormatSettings;
begin
  lMyFormatSettings := TFormatSettings.Create;
  lMyFormatSettings.ThousandSeparator := '.';
  lMyFormatSettings.DecimalSeparator := ',';

  Result := FormatFloat('#,##0', pValor, lMyFormatSettings);
end;

class function THelperServer.GerarDataExcel(pValor: string): string;
var
  lDataPadrao : TDate;
begin
  lDataPadrao := StrToDate('01/01/1900');
  Result := FormatDateTime('dd/mm/yyyy', IncDay(lDataPadrao, StrToInt(pValor) - 2));
end;

class function THelperServer.GetBooleanValor(pValor: string): Boolean;
begin
  Result := (pValor.ToUpper = 'SIM') or (pValor.ToUpper = 'TRUE') or (pValor.ToUpper = '1');
end;

class function THelperServer.GetCodigoBarrasGeradoPeloSistema(
  pCodigoInterno: string): string;
var
  lIndice,
  lSomaPar,
  lSomaImpar,
  lTamanho: Integer;
begin
  pCodigoInterno := GetNumber(pCodigoInterno);

  lTamanho := Length(pCodigoInterno);
  if lTamanho = 9 then
    pCodigoInterno := '789' + pCodigoInterno
  else if lTamanho < 9 then
    pCodigoInterno := str_zero_dir('789', (12 - lTamanho), '0') + pCodigoInterno
  else if lTamanho = 10 then
    pCodigoInterno := '78' + pCodigoInterno
  else if lTamanho = 11 then
    pCodigoInterno := '7' + pCodigoInterno
  else if lTamanho > 12 then
    pCodigoInterno := Copy(pCodigoInterno, 0, 12);

  lSomaPar := 0;
  lSomaImpar := 0;
  for lIndice := 1 to 12 do
    if Par(lIndice) then
      lSomaPar := lSomaPar + StrToInt(pCodigoInterno[lIndice])
    else
      lSomaImpar := lSomaImpar + StrToInt(pCodigoInterno[lIndice]);
  lSomaPar := lSomaPar * 3;
  lIndice := 0;
  while lIndice < (lSomaPar + lSomaImpar) do
    Inc(lIndice, 10);

  Result := pCodigoInterno + IntToStr(lIndice - (lSomaPar + lSomaImpar));
end;

class function THelperServer.GetDataExcel(pData: string): string;
var
  lJSDate: TJSDate;
begin
  Result := pData;

  if Trim(pData) <> '' then
  begin
    lJSDate := TJSDate.New(Result);
    Result := FormatDateTime('dd/mm/yyyy', EncodeDate(lJSDate.UTCFullYear, lJSDate.UTCMonth + 1, lJSDate.UTCDate));
  end;
end;

class function THelperServer.GetIdCombo(pCds: TXDataWebDataSet;
  pIndex: Integer): Integer;
begin
  pcds.RecNo := pIndex;

  Result := pCds.FieldByName('id').AsInteger;
end;

class function THelperServer.GetMensagemBotaoSalvar(pInsert: Boolean;
  pTela: string): string;
var
  lTipoOperacao : string;
begin
  lTipoOperacao := 'cadastrar';

  if not pInsert then
    lTipoOperacao := 'alterar';

  Result := 'Tem certeza que deseja ' +lTipoOperacao + ' este ' + pTela + '?';
end;

class function THelperServer.GetMensagemPadraoSalvar(
  pInserting: Boolean): string;
begin
  if pInserting then
    Result := 'Tem certeza que deseja salvar os dados?'
  else
    Result := 'Tem certeza que deseja atualizar os dados?';
end;

class function THelperServer.GetMensagemPadraoSalvarSucesso(
  pInserting: Boolean): string;
begin
  if pInserting then
    Result := 'Dados cadastrados com sucesso!'
  else
    Result := 'Dados atualizados com sucesso!';
end;

class function THelperServer.GetNumber(pAText, pAFromText,
  AToText: string): string;
var
  lI: Byte;
begin
  Result := EmptyStr;
  for lI := 1 to Length(pAText) do
  begin
    if ((pAText[lI] >= '0') and (pAText[lI] <= '9')) or (pAText[lI] = '-') then
      Result := Result + pAText[lI]
    else if pAText[lI] = pAFromText then
      Result := Result + AToText
    else if pAText[lI] = AToText then
      Result := Result + AToText;
  end;
end;

class function THelperServer.GetStatusAssociacao(pStatus: string): string;
begin
  Result := 'SEM PRODUTO ASSOCIADO';

  if (pStatus = '') or (pStatus.ToUpper = 'NULL') then
    Exit;

  case StrToInt(pStatus) of
    1: Result := 'ASSOCIADO';
    2: Result := 'AGUARDANDO VALIDAÇÃO FOTO';
    3: Result := 'AGUARDANDO VALIDAÇÃO CADASTRO';
  end;
end;

class function THelperServer.GetStatusAssociacaoProdutoRounded(
  pStatus: string): string;
begin
  if pStatus.ToUpper = 'NULL' then
    pStatus := '0';

  case StrToInt(pStatus) of
    0 : Result := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">DESASSOCIADO</div>';
    1 : Result := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">ASSOCIADO</div>';
    2 : Result := '<div class="rounded-pill" style="background-color: #1E90FF;color:white; padding-right: 5px;padding-left: 5px;">AGUARDANDO VALIDAÇÃO FOTO</div>';
    3 : Result := '<div class="rounded-pill" style="background-color: #0054C3;color:white; padding-right: 5px;padding-left: 5px;">AGUARDANDO VALIDAÇÃO CADASTRO</div>';
  end;
end;

class function THelperServer.GetTelefoneUnicoJson(pJson: string): string;
var
  lArray : TJSArray;
  lObjeto : TJSObject;
  lTelefone : JSValue;
  lIndice : Integer;
  lTelefoneString : string;
begin
  Result := EmptyStr;

  if pJson.IsEmpty then
    Exit;

  lArray := TJSArray(TJSJSON.parse(pJson));
  lTelefoneString := EmptyStr;

  for lIndice := 0 to lArray.length - 1 do
  begin
    lObjeto := TJSObject(lArray[lIndice]);

    lTelefone := lObjeto['telefone'];

    if lTelefone = nil then
      Continue
    else
    begin
      lTelefoneString := string(lTelefone);
      lTelefoneString := TUtils.FormatarTelefone(lTelefoneString);
      Break;
    end;
  end;

  Result := lTelefoneString;
end;

class function THelperServer.GetTempoSincronizacao(pInicio,
  pFim: string): string;
var
  lHoras,
  lMinutos,
  lSegundos: Integer;
  lDiferencaTotalSegundos: Int64;
begin
  Result := EmptyStr;

  if not((pInicio = 'null') or (pInicio = '')) and not((pFim = 'null') or (pFim = '')) then
  begin
    lDiferencaTotalSegundos := SecondsBetween(StrToDateTime(pInicio), StrToDateTime(pFim));

    lHoras := lDiferencaTotalSegundos div 3600;
    lDiferencaTotalSegundos := lDiferencaTotalSegundos mod 3600;

    lMinutos := lDiferencaTotalSegundos div 60;
    lSegundos := lDiferencaTotalSegundos mod 60;

    Result := Format('%.2d', [lHoras]) + ':' + Format('%.2d', [lMinutos]) + ':' + Format('%.2d', [lSegundos]);
  end;
end;

class function THelperServer.GetTextoMax100Caracteres(pTexto: string) : string;
begin
  Result := pTexto;

  if Length(pTexto) > 100 then
    Result := Copy(pTexto, 1, 100) + '...';
end;

class function THelperServer.GetTodosTelefonesJson(pJson: string): string;
var
  lArray : TJSArray;
  lObjeto : TJSObject;
  lTelefone : JSValue;
  lIndice,
  lIndiceTelefone : Integer;
  lTelefoneString,
  lListaTelefones : string;
begin
  Result := EmptyStr;

  if pJson.IsEmpty then
    Exit;

  lArray := TJSArray(TJSJSON.parse(pJson));
  lListaTelefones := EmptyStr;
  lIndiceTelefone := 1;

  for lIndice := 0 to lArray.length - 1 do
  begin
    lObjeto := TJSObject(lArray[lIndice]);

    lTelefone := lObjeto['telefone'];

    if lTelefone = nil then
      Continue
    else
    begin
      lTelefoneString := string(lTelefone);
      lTelefoneString := 'Telefone ' + lIndiceTelefone.ToString + ': ' +  TUtils.FormatarTelefone(lTelefoneString) + ' - ';
      lListaTelefones := lListaTelefones + lTelefoneString;
      Inc(lIndiceTelefone);
    end;
  end;

  if lListaTelefones.IsEmpty then
    Exit;

  Delete(lListaTelefones, Length(lListaTelefones) - 2, 3);

  Result := lListaTelefones;
end;

class function THelperServer.GetValorOrEmpty(pValor: string): string;
begin
  Result := pValor;

  if (pValor.ToUpper = 'NULL') or (Trim(pValor) = EmptyStr)then
    Result := EmptyStr;
end;

class function THelperServer.GetValueOrEmpty(pValor: string): string;
begin
  if (pValor.ToUpper = 'NULL') or (Trim(pValor) = EmptyStr) then
    Result := EmptyStr
  else
    Result := pValor;
end;

class function THelperServer.GetValueOrNull(pValor: string): JSValue;
begin
  Result := pValor;

  if (Trim(pValor) = '') or (pValor.ToUpper = 'NULL') then
    Result := null;
end;

class function THelperServer.IsSelectSomente(const ASQL: string): Boolean;
var
  lValido: Boolean;
begin
  lValido := False;
  asm
    var sql = ASQL;

    // 1. remove comentários de linha (-- ...) e de bloco (/* ... */)
    sql = sql.replace(/--[^\r\n]*/g, ' ');
    sql = sql.replace(/\/\*[\s\S]*?\*\//g, ' ');

    // 2. normaliza (trim)
    sql = sql.trim();

    if (sql !== '') {
      // 3. tira ; final opcional
      if (sql.slice(-1) === ';')
        sql = sql.slice(0, -1).trimEnd();

      // 4. se ainda sobrar ; no meio, são múltiplos comandos -> inválido
      if (sql.indexOf(';') === -1) {
        var sqlUpper = sql.toUpperCase();

        // 5. tem que começar com SELECT ou WITH
        if (sqlUpper.indexOf('SELECT') === 0 || sqlUpper.indexOf('WITH') === 0) {
          // 6. bloqueia palavras de escrita/execução
          var proibidas = ['DELETE','UPDATE','INSERT','DROP','ALTER','CREATE',
            'TRUNCATE','MERGE','EXECUTE','GRANT','REVOKE','COMMIT','ROLLBACK'];
          var achouProibida = false;
          for (var i = 0; i < proibidas.length; i++) {
            var re = new RegExp('\\b' + proibidas[i] + '\\b', 'i');
            if (re.test(sql)) {
              achouProibida = true;
              break;
            }
          }
          lValido = !achouProibida;
        }
      }
    }
  end;
  Result := lValido;
end;

class function THelperServer.Par(pCod: Integer): Boolean;
begin
  Result := pCod mod 2 = 0;
end;

class function THelperServer.PossuiImagem(pValor: string): Boolean;
begin
  Result := not (pValor.IsEmpty) and (pValor.ToUpper <> 'NULL') and (pValor.ToLower <> 'undefined');
end;

class procedure THelperServer.RemoverDiv(pElementoDivId: string);
var
  lElements: TJSHTMLCollection;
  lElement: TJSHTMLElement;
  lIndice: Integer;
begin
  lElements := Document.getElementsByClassName(pElementoDivId);

  for lIndice := lElements.length - 1 downto 0 do
  begin
    lElement := TJSHTMLElement(lElements.item(lIndice));
    if Assigned(lElement) then
      lElement.remove;
  end;
end;

class procedure THelperServer.RemoverElementoPorId(pId: string);
var
  lElement: TJSHTMLElement;
begin
  lElement := TJSHTMLElement(Document.getElementById(pId));

  if Assigned(lElement) then
    lElement.remove;
end;

class procedure THelperServer.SetIndexCombo(pCds: TXDataWebDataSet;
  pValor: Integer; var pCombo: TComboBox);
var
  lIndex : Integer;
begin
  if pCds.Locate('id', pValor,[loCaseInsensitive,loPartialKey]) then
    lIndex := pCds.RecNo;

  pCombo.ItemIndex := lIndex;
end;

class function THelperServer.str_zero_dir(pStr: string; pTamanho: Integer;
  pCaracter: Char): string;
begin
  if (pTamanho > 0) and (Length(pStr) > pTamanho) then
    Result := Copy(pStr, 1, pTamanho)
  else
    Result := pStr + StringOfChar(pCaracter, pTamanho - length(pStr));
end;

class function THelperServer.ValidarDatasMovimentos(pDataInicial,
  pDataFinal: string): string;
var
  lDataInicial,
  lDataFinal : TDate;
begin
  Result := EmptyStr;

  if (Trim(pDataInicial).IsEmpty) or (Trim(pDataFinal).IsEmpty) then
  begin
    Result := 'Data inicial e final são obrigatórias!';
    Exit;
  end;

  lDataInicial := StrToDate(FormatarDataPTBR(pDataInicial));
  lDataFinal := StrToDate(FormatarDataPTBR(pDataFinal));

  if lDataInicial > lDataFinal then
  begin
    Result := 'A data inicial deve ser menor que a final!';
    Exit;
  end;

  if DaysBetween(lDataInicial, lDataFinal) > 365 then
  begin
    Result := 'O intervalo entre as datas deve ser menor ou igual a 1 ano!';
    Exit;
  end;
end;

class function THelperServer.ValidarExtensaoImagemProduto(
  pNomeArquivo: string): Boolean;
begin
  Result := True;

  if pNomeArquivo.ToLower.EndsWith('.png') then
    Exit;

  if pNomeArquivo.ToLower.EndsWith('.jpg') then
    Exit;

  if pNomeArquivo.ToLower.EndsWith('.jpeg') then
    Exit;

  if pNomeArquivo.ToLower.EndsWith('.webp') then
    Exit;

  Result := False;
end;

class function THelperServer.ValidarTamanhoImagemProduto(pSize: Integer): Boolean;
const
  MAX_SIZE = 1 * 1024 * 1024;
begin
  Result := True;

  Result := pSize <= MAX_SIZE;
end;

class function THelperServer.VerificarCampoVazio(pEdit: TDBEdit): Boolean;
begin
  Result := False;

  Result := Trim(pEdit.Text).IsEmpty;
end;

class function THelperServer.VerificarJsonArrayValido(const pJson: string): Boolean;
var
  lValido: Boolean;
begin
  lValido := False;
  asm
    try {
      var dados = JSON.parse(pJson);
      lValido = Array.isArray(dados) && dados.length > 0;
    } catch (e) {
      lValido = false;
    }
  end;
  Result := lValido;
end;

class function THelperServer.VerificarJsonValido(pJson: string): Boolean;
var
  lObj: JSValue;
  lValues: JSValue;
begin
  Result := False;

  if Trim(pJson) = '' then
    Exit;

  try
    lObj := TJSJSON.parse(pJson);
    if not JS.isObject(lObj) then
      Exit;
    lValues := TJSObject(lObj)['values'];
    Result := JS.isArray(lValues);
  except
    Result := False;
  end;
end;

end.

